






























import { Component, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { SystemCode } from '@/api'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import { Col } from '@/components/molecules/DataTable'

const COLS: Col[] = [
  {
    width: '40',
    resizable: true,
    items: [
      {
        name: 'copyType',
        headerText: '区分'
      }
    ]
  },
  {
    width: '30',
    resizable: true,
    items: [
      {
        name: 'counter',
        headerText: '件数'
      }
    ]
  },
  {
    width: '30',
    resizable: true,
    items: [
      {
        name: 'counterNumber',
        headerText: '枚数'
      }
    ]
  }
]

export interface UsageStatisticsCopyTableItem {
  copyType: SystemCode
  counter: {
    input: string
  }
  counterNumber: {
    input: string
  }
}

@Component({
  components: { DataTable }
})
export default class UsageStatisticsCopyTable extends ComponentVue {
  @PropSync('inputs', {
    type: Array,
    required: true
  })
  inputItems!: UsageStatisticsCopyTableItem[]

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  get numberMask(): string {
    return '#'.repeat(5)
  }

  get cols(): Col[] {
    return COLS
  }
}
